var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0.5C10.9033 0.5 10.331 0.737053 9.90901 1.15901C9.48705 1.58097 9.25 2.15326 9.25 2.75C9.25046 2.89111 9.26419 3.03187 9.29102 3.17041L3.95459 6.2832C3.54813 5.93888 3.03269 5.74994 2.5 5.75C1.90326 5.75 1.33097 5.98705 0.90901 6.40901C0.487053 6.83097 0.25 7.40326 0.25 8C0.25 8.59674 0.487053 9.16903 0.90901 9.59099C1.33097 10.0129 1.90326 10.25 2.5 10.25C3.03187 10.249 3.54618 10.0595 3.95166 9.71533L9.29102 12.8296C9.26419 12.9681 9.25046 13.1089 9.25 13.25C9.25 13.8467 9.48705 14.419 9.90901 14.841C10.331 15.2629 10.9033 15.5 11.5 15.5C12.0967 15.5 12.669 15.2629 13.091 14.841C13.5129 14.419 13.75 13.8467 13.75 13.25C13.75 12.6533 13.5129 12.081 13.091 11.659C12.669 11.2371 12.0967 11 11.5 11C10.9676 11.0007 10.4527 11.1901 10.0469 11.5347L4.70898 8.42041C4.73581 8.28187 4.74954 8.14111 4.75 8C4.74954 7.85889 4.73581 7.71813 4.70898 7.57959L10.0454 4.4668C10.4519 4.81112 10.9673 5.00006 11.5 5C12.0967 5 12.669 4.76295 13.091 4.34099C13.5129 3.91903 13.75 3.34674 13.75 2.75C13.75 2.15326 13.5129 1.58097 13.091 1.15901C12.669 0.737053 12.0967 0.5 11.5 0.5Z",
    fill: "#1F4C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.f4d56c423e5d00e10e13d76a4333da00.svg";
export { ForwardRef as ReactComponent };